export function formatDateTime (value) {
  if (!value) return 'Fecha no disponible'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'Fecha no disponible'
  return new Intl.DateTimeFormat('es-CL', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
  }).format(date)
}

export function normalizeDateInputValue (value) {
  if (!value) return ''

  if (typeof value === 'string') {
    if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
      return value.slice(0, 10)
    }

    const parsed = new Date(value)
    if (!Number.isNaN(parsed.getTime())) {
      const year = parsed.getUTCFullYear()
      const month = String(parsed.getUTCMonth() + 1).padStart(2, '0')
      const day = String(parsed.getUTCDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    return ''
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getUTCFullYear()
    const month = String(value.getUTCMonth() + 1).padStart(2, '0')
    const day = String(value.getUTCDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  return ''
}

export function formatDateOnly (value) {
  const normalized = normalizeDateInputValue(value)
  if (!normalized) return 'Sin información'

  const [year, month, day] = normalized.split('-')
  if (!year || !month || !day) return 'Sin información'

  return `${day}/${month}/${year}`
}
